import React from 'react'
import PropTypes from 'prop-types'
import { languagePreference, locale, polyglot } from '../../../index'
import firebase from 'firebase'
import {changeLocale} from '../../../resources/polyglot'
import { Redirect } from 'react-router-dom'
import SectionTitle from '../../common/SectionTitle/SectionTitle'
import Loading from '../../common/Loading/Loading'

export default class Settings extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      languages: undefined,
      currentLanguage: undefined,
      polyglot: polyglot,
      redirectToReferrer: false
    }
    this.getSupportedLanguages = this.getSupportedLanguages.bind(this)
    this.renderLanguageSelect = this.renderLanguageSelect.bind(this)
  }

  componentWillMount () {
    this.setState({
      redirectToReferrer: false
    })
    this.getSupportedLanguages()
  }

  getSupportedLanguages () {
    const rootRef = firebase.database().ref()
    const configurationRef = rootRef.child('crescendo').child('configurationByCountry').child(locale).child('supportedLanguages')
    configurationRef.on('value', snapshot => {
      this.setState({
        languages: snapshot.val()
      })
    })
  }

  handleLanguageChange (value) {
    changeLocale(value).then(newValues => {
      window.myLogger.info(JSON.stringify({message: 'Changed Language', language: value}))
      this.setState({
        polyglot: newValues,
        currentLanguage: value
      })
      this.props.handleLanguageChange(newValues, value)
    })
  }

  renderLanguageSelect () {
    if (this.state.languages) {
      return <div className='col-xs-12'>
        <select defaultValue={window.localStorage.getItem(languagePreference)} onChange={e => (this.handleLanguageChange(e.target.value))}>
          {this.state.languages.map(element => {
            return <option key={element.value} value={element.value} label={element.label}>{element.label}</option>
          })}
        </select>
      </div>
    }
  }
  render () {
    if (this.state.languages) {
      return <div className='container'>
        {this.state.redirectToReferrer && (
          <Redirect to='/settings' />
        )}
        <SectionTitle title={polyglot.t('staticFields.settings.changeLanguage')} size={'h3'} />
        {this.renderLanguageSelect()}
      </div>
    } else {
      return <Loading />
    }
  }
}

Settings.propTypes = {
  handleLanguageChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Settings/Settings.js